module.exports = __webpack_public_path__ + "static/73f85087.partner-palpal-logo.svg";